<template>
    <div class="device-type-manange relative">
        <div class="buttons">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="5" :xl="6" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">&ensp;&ensp;&ensp;&ensp;特属专家姓名：</span>
                <el-input v-model="doctor_name" placeholder="特属专家姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="5" :xl="6" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">特属服务对象姓名：</span>
                <el-input v-model="user_name" placeholder="特属服务对象姓名模糊搜索"/>
            </el-col>
        </el-row>
        <!-- 表单结束 -->

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column width="50px" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="140" prop="doctor_name" label="特属专家姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="140" prop="doctor_mobile" label="特属专家电话" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="140" prop="user_name" label="特属服务对象姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="140" prop="user_mobile" label="特属服务对象电话" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="healthrecord_update_date" label="健康档案最新更新时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="190" prop="first_meet_time" label="健康档案更新首次会面时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="210" class-name="admin_user_name" prop="admin_user_name" label="特属服务专员" align="center" label-class-name="label" v-if="role_id != 2 && child_role_id == 0"></el-table-column>
            <el-table-column width="200" label="超时时间" align="center" label-class-name="label">
                <template slot-scope="scope">
                    <span class="red">{{ scope.row.timeout_txt }}</span>
                </template>
            </el-table-column>
            <el-table-column width="100" prop="number" label="健康档案未更新次数" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="80" prop="address" label="操作" align="center" label-class-name="label" v-slot="scope">
                <el-button :id="'doctorEdit'" @click="goDetail(scope.row)"
                           type="text" size="mini">查看
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
                v-if="is_pagination_show"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {getUserInfos} from "@/utils/userInfos";

    export default {
        data() {
            return {
                role_id: 0,
                child_role_id: 0,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                user_name: '',
                doctor_name: '',
                start_date: '',
                end_date: '',
                search_expired_date: '',
                dataLen: 0,
                is_pagination_show: true,
            };
        },
        created() {
        },
        mounted() {
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
                this.child_role_id = parseInt(userInfo.child_role_id)
            }
            let prev_page = localStorage.getItem('prev_page');

            if (prev_page == 'content_chat_detail') {
                localStorage.setItem('prev_page', 'content_noreply')
                this.user_name = localStorage.getItem('content_noreply_user_name')
                this.doctor_name = localStorage.getItem('content_noreply_doctor_name')
                this.page = parseInt(localStorage.getItem('page'))
                this.perpage = parseInt(localStorage.getItem('perpage'))
                if (this.user_name == 'undefined' || this.user_name == 'null') {
                    this.user_name = ''
                }
                if (this.doctor_name == 'undefined' || this.doctor_name == 'null') {
                    this.doctor_name = ''
                }
                this.is_pagination_show = false;

            }

            // 获取列表
            this.getList();
            this.timer = setInterval(() => {

                if (this.dataLen > 0) {
                    for (let i = 0; i < this.dataLen; i++) {
                        this.tableData[i].timeout_txt = this.dateToTxt(this.tableData[i].meet_timestamp)
                    }
                }
            }, 1000);

        },
        methods: {
            // 获取超时未更新健康档案记录
            getList() {
                let params = {
                    servername: 'Ruyi_AdminExpertServices',
                    method: 'healthrecordTimeoutLogList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_name: this.user_name,
                        doctor_name: this.doctor_name,
                        start_date: this.start_date,
                        end_date: this.end_date,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.dataLen = res.data.data.list.length
                    for (var i = 0; i < this.dataLen; i++) {
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        res.data.data.list[i].timeout_txt = this.dateToTxt(res.data.data.list[i].meet_timestamp)
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;

                    localStorage.setItem('content_noreply_user_name', this.user_name)
                    localStorage.setItem('content_noreply_doctor_name', this.doctor_name)
                    localStorage.setItem('prev_page', 'content_noreply')
                    localStorage.setItem('page', this.page)
                    localStorage.setItem('perpage', this.perpage)
                    this.is_pagination_show = true
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.user_name = "";
                this.doctor_name = "";
                this.user_role = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }
                this.getList();
            },

            // 详情
            goDetail(data) {
                this.$router.push({
                    name: "workList", params: {
                        user_name: data.user_name,
                        doctor_name: data.doctor_name,
                        status: '3',
                    }
                });
            },
            // 时间日期差
            dateToTxt(time_date) {
                let timeDate = parseInt((new Date(time_date)).getTime() / 1000); // 日期转秒
                let timeNow = parseInt((new Date()).getTime() / 1000);
                let sec = timeNow - timeDate;
                // let s = secs % 60;
                let m = (parseInt(sec / 60) ) % 60;
                let H = (parseInt(sec / 3600) ) % 24;
                // let d = (parseInt(secs / 86400) ) % 365;
                let d = parseInt(sec / 86400);
                // let txt = `${s}秒`;
                let txt = '';
                // txt = m > 0 ? `${m}分钟${txt}`: txt;
                txt = H > 0 ? `${H}小时${txt}`: txt;
                txt = d > 0 ? `${d}天${txt}`: txt;
                // if (d > 7) {
                //     txt = '7天+';
                // }
                return txt
            }
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .red{
        color: #df1400;
    }
    .el-table .admin_user_name .cell{
        white-space: pre-wrap;
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
</style>
